// utils/currency.js (front)
// Même taux que le backend. Sert uniquement à l'affichage et à l'aperçu
// pendant la saisie. Les prix stockés restent en EUR côté base.
export const KMF_PER_EUR = 491.96775;

export const eurToKmf = (amount) => {
  const n = Number(amount);
  if (!n || isNaN(n)) return 0;
  return Math.round(n * KMF_PER_EUR);
};

export const formatKmf = (amount) => {
  const n = Number(amount);
  if (!n || isNaN(n)) return "0";
  return n.toLocaleString("fr-FR");
};